import { useEffect, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ContinueButton } from '../ContinueButton';
import * as S from './styled';

interface ModalProps {
  isOpen: boolean;
  children: ReactNode;
  modalId: number;
  onSignupClick?: () => void;
  isBlurred?: boolean;
  buttonName?: string;
  fixed?: boolean;
}

export const Modal = ({
  isOpen,
  children,
  onSignupClick,
  modalId,
  isBlurred,
  buttonName = 'sign_up',
  fixed = false,
}: ModalProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const { t } = useTranslation();
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (isOpen) {
      document.body.style.overflowY = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
      timeoutId = setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else {
      setIsVisible(false);
    }

    return () => {
      clearTimeout(timeoutId);
      if (isOpen) {
        document.body.style.overflowY = 'unset';
        document.documentElement.style.overflowY = 'unset';
      }
    };
  }, [isOpen]);

  if (!isOpen && !isVisible) return null;

  return (
    <S.ModalOverlay $isVisible={isVisible} $isBlurred={isBlurred}>
      <S.ModalContent $isVisible={isVisible} $fixed={fixed} id={`modal-div_${modalId}`}>
        {children}
        {onSignupClick && (
          <ContinueButton
            onClick={onSignupClick}
            customText={t(`${buttonName}`)}
            mt={16}
            customStyles={{
              minHeight: '56px',
              fontSize: '18px',
              fontWeight: '600',
            }}
          />
        )}
      </S.ModalContent>
    </S.ModalOverlay>
  );
};
